<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="vx-row">
      <vx-card>
        <div class="vx-row float-right my-3">
          <div class="vx-col w-full">
            <vs-button
              v-if="false"
              icon-pack="feather"
              icon="icon-list"
              @click="treeview = !treeview"
              size="small"
              >{{ $t("setup.label.listview") }}</vs-button
            >
          </div>
        </div>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="addresss"
          :description="!treeview"
          :search="!treeview"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.AddressMaster") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-git-branch"
                @click="$router.push({ name: 'Address Master Tree View' })"
                size="small"
                >{{ $t("setup.label.TreeView") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="add('Country')"
                size="small"
                >{{ $t("setup.label.AddCountry") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.CountryName") }}</vs-th>
            <vs-th>{{ $t("setup.label.StateName") }}</vs-th
            ><vs-th>{{ $t("setup.label.DistrictName") }}</vs-th>
            <vs-th>{{ $t("setup.label.CityName") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="address"
              v-for="(address, index) in data"
            >
              <vs-td :data="address.countryName">{{
                address.countryName
              }}</vs-td>
              <vs-td :data="address.stateName">{{ address.stateName }}</vs-td>
              <vs-td :data="address.districtName">{{
                address.districtName
              }}</vs-td>
              <vs-td :data="address.cityName">{{ address.cityName }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div v-if="false">
          <tree-item
            :node="treedata"
            @add-in="addIn"
            @edit-item="editItem"
            @delete-item="deleteItem"
            @service-available="serviceAvailable"
          ></tree-item>
        </div>
      </vx-card>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('setup.label.Delete') + title"
        :active.sync="deletePopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">{{$t("setup.label.Are_you_sure_?")}}</div>
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button
                type="border"
                @click="
                  resetForm();
                  deletePopup = false;
                "
                >{{ $t("setup.label.Cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="removeItem" color="warning">{{
                $t("setup.label.Ok")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!-- //Addd -->
    <div class="centerx">
      <vs-popup
        class="popup-close"
        :title="$t('setup.label.AddCountry')"
        :active.sync="addPopup"
      >
        <ValidationObserver ref="observer">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-full w-full">
                <div class="vx-col sm:w-full w-full">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('setup.label.CountryCode')"
                    :key="resetKey"
                  >
                    <vs-input
                      :label="$t('setup.label.CountryCode')"
                      type="text"
                      v-model="addObj.entityCode"
                      :placeholder="$t('setup.label.EnterCountryCode')"
                      class="w-full mb-2 font-semibold starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col sm:w-full w-full mt-5">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.CountryName')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('setup.label.CountryName')"
                    type="text"
                    v-model="addObj.entityName"
                    :placeholder="$t('setup.label.EnterCountryName')"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row justify-center">
              <span class="ml-4 mr-1">
                <vs-button type="border" @click="addPopup = false">{{
                  $t("setup.label.Cancel")
                }}</vs-button>
              </span>
              <span class="ml-1 mr-2">
                <vs-button @click="addEntity">{{
                  $t("setup.label.Submit")
                }}</vs-button>
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
    <!--///Services-->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('setup.label.Edit') + title"
        :active.sync="servicePopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">
                <vs-input
                  :label="title + $t('setup.label.Code')"
                  type="text"
                  v-model="addObj.entityCode"
                  class="w-full font-semibold"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full w-full">
              <vs-input
                :label="title + $t('setup.label.Name')"
                type="text"
                v-model="addObj.entityName"
                class="w-full font-semibold"
              />
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="servicePopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="editEntity">{{
                $t("setup.label.Save")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import TreeItem from "./TreeBrowser.vue";
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const addEmptyObj = {
  entityName: "",
  entityCode: "",
};
export default {
  data() {
    return {
      resetKey: 0,
      loading: false,
      addObj: addEmptyObj,
      searchOption: 0,
      addressTreeObj: [],
      descriptionItems: [5, 10, 15],
      deletePopup: false,
      addPopup: false,
      editPopup: false,
      servicePopup: false,
      treeview: false,
      delId: 0,
      addresss: [],
      searchword: "",
      initSelected: ["node-1"],
      treedata: { name: "Root", id: 0, change: 0, children: [] },
      id: "",
      title: "",
      parentId: 0,
      errorMessage: "",
      warningPopup: false,
      warningText: "",
    };
  },
  components: {
    AtomSpinner,
    "tree-item": TreeItem,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      addressData: (state) => state.addressMaster.addressData,
    }),
  },
  methods: {
    async getaddressList() {
      this.loading = true;
      try {
        await this.$store.dispatch("addressMaster/fetchAddressData");
        this.addresss = this.addressData;
      } catch (e) {
        console.log("something went to wrong while addresss:", e);
      }
      this.loading = false;
    },
    async addEntity() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        if (this.title === "Country") {
          await this.$store.dispatch(
            "addressMaster/saveCountryAction",
            this.addObj
          );
        }
        if (this.title === "State") {
          this.addObj.parentEntityId = this.parentId;
          await this.$store.dispatch(
            "addressMaster/saveStateAction",
            this.addObj
          );
        }
        if (this.title === "District") {
          this.addObj.parentEntityId = this.parentId;
          await this.$store.dispatch(
            "addressMaster/saveDistrictAction",
            this.addObj
          );
        }
        if (this.title === "City") {
          this.addObj.parentEntityId = this.parentId;
          await this.$store.dispatch(
            "addressMaster/saveCityAction",
            this.addObj
          );
        }
        this.addPopup = false;
        this.treedata.change += 1;
        this.getaddressList();
        this.convertTree(this.addresss);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async removeItem() {
      try {
        if (this.title === "Country") {
          await this.$store.dispatch(
            "addressMaster/deleteCountryAction",
            this.id
          );
          this.getaddressList();
        }
        if (this.title === "State") {
          await this.$store.dispatch(
            "addressMaster/deleteStateAction",
            this.id
          );
          this.getaddressList();
        }
        if (this.title === "District") {
          await this.$store.dispatch(
            "addressMaster/deleteDistrictAction",
            this.id
          );
          this.getaddressList();
        }
        if (this.title === "City") {
          await this.$store.dispatch("addressMaster/deleteCityAction", this.id);
          this.getaddressList();
        }
        this.treedata.change += 1;
        this.getaddressList();
        this.deletePopup = false;
      } catch {}
    },
    async editEntity() {
      try {
        if (this.title === "Country") {
          delete this.addObj.parentEntityId;
          await this.$store.dispatch("addressMaster/editCountryAction", {
            id: this.id,
            data: this.addObj,
          });
        }
        if (this.title === "State") {
          delete this.addObj.parentEntityId;
          await this.$store.dispatch("addressMaster/editStateAction", {
            id: this.id,
            data: this.addObj,
          });
        }
        if (this.title === "District") {
          delete this.addObj.parentEntityId;
          await this.$store.dispatch("addressMaster/editDistrictAction", {
            id: this.id,
            data: this.addObj,
          });
        }
        if (this.title === "City") {
          delete this.addObj.parentEntityId;
          await this.$store.dispatch("addressMaster/editCityAction", {
            id: this.id,
            data: this.addObj,
          });
        }
        this.editPopup = false;
        this.treedata.change += 1;
        this.resetForm();
        this.getaddressList();
        this.convertTree(this.addresss);
        this.$router.push("/setup/address-master").catch(() => {});
        if (resp.data.resourceId && resp.data.resourceId) {
          //
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating entity:", e);
      }
    },

    editData(id) {
      this.$router.push(`/editaddress/${id}`);
    },
    resetForm() {
      this.addObj = addEmptyObj;
      this.addObj.entityCode = "";
      this.addObj.entityName = "";
    },
    addDistricts(val) {
      //
    },
    addIn(id, type, code) {
      if (type === "country") {
        this.title = "State";
        this.parentId = id;
        this.addPopup = true;
      } else if (type === "state") {
        this.title = "District";
        this.parentId = id;
        this.addPopup = true;
      } else if (type === "district") {
        this.title = "City";
        this.parentId = id;
        this.addPopup = true;
      }
      (this.addObj.entityCode = ""), (this.addObj.entityName = "");
    },
    editItem(id, type, code, name) {
      if (type === "country") {
        this.title = "Country";
        this.id = id;
        this.addObj.entityCode = code;
        this.addObj.entityName = name;

        this.editPopup = true;
      } else if (type === "state") {
        this.title = "State";
        this.addObj.entityCode = code;
        this.addObj.entityName = name;
        this.id = id;
        this.editPopup = true;
      } else if (type === "district") {
        this.title = "District";
        this.id = id;
        this.addObj.entityCode = code;
        this.addObj.entityName = name;
        this.editPopup = true;
      } else if (type === "city") {
        this.title = "City";
        this.id = id;
        this.addObj.entityCode = code;
        this.addObj.entityName = name;
        this.editPopup = true;
      }
    },
    deleteItem(id, type, code) {
      if (type === "country") {
        this.title = "Country";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "state") {
        this.title = "State";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "district") {
        this.title = "District";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "city") {
        this.title = "City";
        this.id = id;
        this.deletePopup = true;
      }
    },
    serviceAvailable(id, type, code) {
      if (type === "country") {
        this.title = "Country";
        this.id = id;
        this.servicePopup = true;
      }
    },
    add(title) {
      this.title = title;
      this.addPopup = true;
      this.resetKey++;
    },
    convertTree(val) {},
  },
  watch: {
    addresss(val) {
      this.convertTree(val);
      this.addDistricts(val);
    },
  },
  created() {
    this.getaddressList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.tree-block {
  float: left;
  width: 33%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px dotted #ccccdd;
  overflow: auto;
  height: 800px;
}
.treebtn1 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 1px 3px;
  border-radius: 5px;
  margin-right: 5px;
  color: rgb(148, 147, 147);
}
.treebtn2 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 3px 5px;
  border-radius: 5px;
  margin-left: 5px;
  color: rgb(97, 97, 97);
}
.treebtn3 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 3px 5px;
  border-radius: 5px;
  margin-left: 5px;
  color: rgb(63, 63, 63);
}
.tree-search-input {
  width: 70%;
  padding: 6px 8px;
  outline: none;
  border-radius: 6px;
  border: 1px solid #ccc;
}
.tree-search-btn {
  width: 25%;
  padding: 6px 8px;
  outline: none;
  border-radius: 6px;
  background-color: rgb(218, 218, 218);
  border: 1px solid rgb(226, 225, 225);
  color: rgb(117, 117, 117);
}
</style>
